import { useQuery } from "@tanstack/react-query";
import type { CouponView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseCouponsQueryParams = {
  storeSlug: string;
};

export function useCouponsQuery({ storeSlug }: UseCouponsQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.seller.coupons(storeSlug),
    queryFn: () => apiJsonClient<CouponView[]>(endpoints.seller.coupons),
    enabled: storeSlug.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
